export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset.36e8c438.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};